export const capitalizeFirstLetter = (lowercaseString: string) => {
  return lowercaseString.charAt(0).toUpperCase() + lowercaseString.slice(1)
}
